export enum InvalidKeys {
  loadingKey = 'loadingKey',
  errorKey = 'errorKey',
  emptyKey = 'emptyKey',
}
